import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout/Layout";
import Users from "./pages/Users";
import Partners from "./pages/Partners";
import Orders from "./pages/Orders";
import Sleeves from "./pages/Sleeves";
import ToasterHost from "./components/ToasterHost";

import { PermissionsProvider } from "./auth/PermissionsProvider";
import Testing from "./pages/Testing";
import Couriers from "./pages/Couriers";

// Protected Route Component with loading guard
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          {/* <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
            }}
          /> */}
          <ToasterHost />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <PermissionsProvider>
                    <Layout />
                  </PermissionsProvider>
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="partners" element={<Partners />} />
              <Route path="orders" element={<Orders />} />
              <Route path="sleeves" element={<Sleeves />} />
              <Route path="couriers" element={<Couriers />} />
              <Route path="test" element={<Testing />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
